// @ts-nocheck
import { AppShortcuts } from '@capawesome/capacitor-app-shortcuts';
import { Capacitor } from '@capacitor/core';
import { UserData, Community } from '../types';

const imageToBase64 = async (url: string): Promise<string> => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (e) {
        console.warn('Failed to convert image to base64 for shortcut:', url);
        return '';
    }
};

export const updateAppShortcuts = async (
    usersData: Record<string, any>,
    loggedInAccounts: string[],
    communities: any[]
) => {
    if (!Capacitor.isNativePlatform()) return;

    try {
        // Collect default shortcuts
        const shortcuts: any[] = [
            {
                id: 'default_communities',
                title: 'Communities',
                description: 'View your communities',
                androidIcon: 'ic_menu_myplaces', // Built-in android drawable or we can just omit
                iosIcon: 'person.3.fill'
            },
            {
                id: 'default_footprint',
                title: 'Footprint',
                description: 'Your digital footprint',
                androidIcon: 'ic_menu_recent_history',
                iosIcon: 'shoeprints.fill'
            },
            {
                id: 'default_art_class',
                title: 'Art Class',
                description: 'Draw and create',
                androidIcon: 'ic_menu_gallery',
                iosIcon: 'paintpalette.fill'
            }
        ];

        // Gather unique quick actions from all logged-in profiles
        const uniqueActions = new Map<string, any>();

        for (const userId of loggedInAccounts) {
            const user = usersData[userId];
            if (user?.quickActions) {
                // user.quickActions should be an array of objects: { type: 'community' | 'mod', targetId: string }
                for (const action of user.quickActions) {
                    const key = `${action.type}_${action.targetId}`;
                    if (!uniqueActions.has(key)) {
                        uniqueActions.set(key, action);
                    }
                }
            }
        }

        // Process custom actions (Limit total shortcuts to 5 usually for OS limits, so 3 defaults + 2 custom max, but let's send them all and let OS truncate)
        let processedCount = 0;
        for (const action of uniqueActions.values()) {
            if (processedCount >= 3) break; // Arbitrary limit to prevent huge payloads

            if (action.type === 'community') {
                const community = communities.find(c => c._id === action.targetId);
                if (community) {
                    let base64Icon = '';
                    if (Capacitor.getPlatform() === 'android' && community.avatar) {
                        base64Icon = await imageToBase64(community.avatar);
                    }
                    
                    shortcuts.push({
                        id: `community_${community._id}`,
                        title: community.name,
                        description: `Open ${community.name}`,
                        androidIcon: base64Icon || 'ic_menu_compass',
                        iosIcon: 'person.2.circle.fill'
                    });
                    processedCount++;
                }
            } else if (action.type === 'mod') {
                shortcuts.push({
                    id: `mod_${action.targetId}`,
                    title: action.title || 'Mod', // Pass title in the action obj
                    description: `Open ${action.title || 'Mod'}`,
                    iosIcon: 'wrench.and.screwdriver.fill'
                });
                processedCount++;
            }
        }

        await AppShortcuts.set({ shortcuts });
        console.log('App shortcuts updated successfully!');
    } catch (error) {
        console.error('Error updating app shortcuts:', error);
    }
};
